var _path, _path2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShareLinkDownloadMobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.59305 13.2235C8.69551 13.3308 8.83998 13.3976 9 13.3976C9.16002 13.3976 9.30451 13.3308 9.40697 13.2235L12.4656 10.1644C12.6855 9.94444 12.6855 9.58894 12.4656 9.369C12.2456 9.14906 11.8901 9.14906 11.6702 9.369L9.5625 11.4771V0.5625C9.5625 0.252 9.3105 0 9 0C8.6895 0 8.4375 0.252 8.4375 0.5625V11.4772L6.32925 9.369C6.10931 9.14906 5.75381 9.14906 5.53388 9.369C5.31394 9.58894 5.31394 9.94444 5.53388 10.1644L8.59305 13.2235ZM18 16.5909C18 17.3678 17.3678 18 16.5909 18H1.4085C0.63225 18 0 17.3678 0 16.5909V9C0 8.6895 0.252 8.4375 0.5625 8.4375C0.873 8.4375 1.125 8.6895 1.125 9V16.5909C1.125 16.7473 1.25213 16.875 1.4085 16.875H16.5909C16.7473 16.875 16.875 16.7473 16.875 16.5909V9C16.875 8.6895 17.1264 8.4375 17.4375 8.4375C17.7486 8.4375 18 8.6895 18 9V16.5909Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4773_61996",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 18,
    height: 18
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.59305 13.2235C8.69551 13.3308 8.83998 13.3976 9 13.3976C9.16002 13.3976 9.30451 13.3308 9.40697 13.2235L12.4656 10.1644C12.6855 9.94444 12.6855 9.58894 12.4656 9.369C12.2456 9.14906 11.8901 9.14906 11.6702 9.369L9.5625 11.4771V0.5625C9.5625 0.252 9.3105 0 9 0C8.6895 0 8.4375 0.252 8.4375 0.5625V11.4772L6.32925 9.369C6.10931 9.14906 5.75381 9.14906 5.53388 9.369C5.31394 9.58894 5.31394 9.94444 5.53388 10.1644L8.59305 13.2235ZM18 16.5909C18 17.3678 17.3678 18 16.5909 18H1.4085C0.63225 18 0 17.3678 0 16.5909V9C0 8.6895 0.252 8.4375 0.5625 8.4375C0.873 8.4375 1.125 8.6895 1.125 9V16.5909C1.125 16.7473 1.25213 16.875 1.4085 16.875H16.5909C16.7473 16.875 16.875 16.7473 16.875 16.5909V9C16.875 8.6895 17.1264 8.4375 17.4375 8.4375C17.7486 8.4375 18 8.6895 18 9V16.5909Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4773_61996)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "#1B8C96"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareLinkDownloadMobile);
export default __webpack_public_path__ + "static/media/share-link-download-mobile.d7757598627216b5d8cb30dea12bdc63.svg";
export { ForwardRef as ReactComponent };